import { useState, useRef, useEffect } from "react";
import * as Components from "../";
import { Input, Button, Modal, Form, InputNumber, Table } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { PRICE_PARSERS, owntoast } from "../../utils";
import { DiscountTableColumn, ClosePaymentData } from "../../data/Columns";
import dayjs from "dayjs";
import { useReactToPrint } from "react-to-print";
import { ReceiptType, PaperSize } from "../../utils/enums";
import { SaleBill } from "../SaleBill";
import Hotkeys from "react-hot-keys";
const { Search } = Input;
const { TextArea } = Input;

/* Хоолны зартын жагсаалт болон түүнээс хайх */
function OrderProducts(props) {
  const orderRef = useRef();
  const [text, setText] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const { ressaleproducts } = props;
  const [isPaymentClose, setIsPaymentClose] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [form] = Form.useForm();

  let newDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
  const print = (data) => {
    if (data) {
      let body = {
        amount: data.totalamount,
        products: data.saleDetail,
        setProds: data.salePackSet,
        username: props._auth.username,
        insymd: newDate,
        cash: 0,
        noncash: 0,
        type: ReceiptType.Хаалт,
        totalqty: data.totalqty,
        salePay: data.salePay,
        useramount: data.useramount,
      };
      if (props.rescheckService === true) {
        props.request({
          url: `/print/settlement/${
            props.resprinterconfig && props.resprinterconfig.printertype
              ? props.resprinterconfig.printertype
              : PaperSize.m58
          }`,
          body: body,
          method: "POST",
          isservice: true,
        });
      } else {
        setReceiptData(body);
        printOrder();
      }
    }
  };

  const printOrder = useReactToPrint({
    content: () => orderRef.current,
  });

  const searchData = () => {
    if (!ressaleproducts) return [];
    if (text) {
      let newList = ressaleproducts.filter(
        (a) =>
          (a.name && a.name.toLowerCase().includes(text.toLowerCase())) ||
          (a.code && a.code.toLowerCase().includes(text.toLowerCase()))
      );
      return newList;
    } else {
      return ressaleproducts;
    }
  };
  const handleOpen = () => {
    if (props.activeProduct && Object.keys(props.activeProduct).length > 0) {
      if (props.activeProduct.isset === 1) {
        owntoast("Сэт хоолонд хямдрал оруулах боломжгүй.", "error");
      } else {
        setIsOpen(true);
      }
    } else {
      owntoast("Мөр сонгоно уу.", "error");
    }
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
      props.setActiveProduct({});
    }
  }, [isOpen]);

  const handleClosePayment = () => {
    props
      .request({
        url: `/sale/set`,
      })
      .then((res) => {
        if (res.success) {
          form.setFieldsValue({
            cash: res.data.cash,
            noncash: res.data.noncash,
            mobile: res.data.mobile,
            ttlamt: Math.round(
              res.data.cash + res.data.noncash + res.data.mobile
            ),
          });
          setIsPaymentClose(true);
          setIsOpen(true);
        } else {
          owntoast(res.message, "error");
        }
      });
  };

  const handleChangeDiscount = (e) => {
    if (props.activeProduct) {
      form.setFieldsValue({
        unitdiscount: e,
        amount: props.activeProduct.price - e,
        discountPercent: Math.round((e * 100) / props.activeProduct.price, 2),
      });
    }
  };

  const handleDiscount = (values) => {
    let product = { ...props.activeProduct };
    product.unitdiscount = values.discount;
    props.addSaleList({ ...product, type: "discount" });
    form.resetFields();
    setIsOpen(false);
  };

  const onKeyDown = (keyName, e, handle) => {
    if (e.keyCode === 117) {
      handleOpen();
    }
  };

  const closeModal = () => {
    if (isPaymentClose) {
      form.resetFields();
      setIsPaymentClose(false);
      for (var i = 0; i < ClosePaymentData.length; i++) {
        ClosePaymentData[i].qty = 0;
        ClosePaymentData[i].totalamt = 0;
      }
    }
    setIsOpen(false);
  };

  const handleOpenModal = () => {
    setIsOpenWarning(true);
  };

  const handlePaymentClose = (e) => {
    setIsloading(true);
    var money = form.getFieldValue();
    let tmp = {
      cash: money.cash ? Number(money.cash) : 0,
      noncash: money.noncash ? Number(money.noncash) : 0,
      cashmobile: money.mobile ? Number(money.mobile) : 0,
      cost: money.cost ? Number(money.cost) : 0,
      text: money.text ? money.text : "",
    };
    props
      .request({
        url: `/sale/set`,
        method: "POST",
        body: tmp,
      })
      .then((res) => {
        setIsloading(false);
        if (res.success) {
          setIsOpenWarning(false);
          setIsPaymentClose(false);
          setIsOpen(false);
        } else {
          owntoast(res.message, "error");
        }
      });
  };

  const renderData = searchData();

  const searchKeydown = (e) => {
    if (e.keyCode === 13) {
      if (renderData.length === 1) {
        props.addSaleList({
          productid: renderData[0].id,
          productname: renderData[0].name,
          barcode: renderData[0].code,
          qty: 1,
          price: renderData[0].price,
          amount: renderData[0].price,
          discount: 0,
          unitdiscount: 0,
          totalamount: renderData[0].price,
          type: "plus",
        });
        setText("");
      } else {
        owntoast("Бараа олдсонгүй.", "error");
        setText("");
      }
    }
  };

  const priceChange = (e) => {
    var money = form.getFieldsValue();
    if (e.target.id === "cost") {
      form.setFieldsValue({
        ttlamt: new Intl.NumberFormat().format(
          Math.round(
            Number(money.cash ? money.cash : 0) +
              Number(money.noncash ? money.noncash : 0) +
              Number(money.mobile ? money.mobile : 0) -
              Number(e.target.value)
          )
        ),
      });
    } else if (e.target.id === "cash") {
      form.setFieldsValue({
        ttlamt: new Intl.NumberFormat().format(
          Math.round(
            Number(e.target.value) +
              Number(money.noncash ? money.noncash : 0) +
              Number(money.mobile ? money.mobile : 0) -
              Number(money.cost ? money.cost : 0)
          )
        ),
      });
    } else if (e.target.id === "noncash") {
      form.setFieldsValue({
        ttlamt: new Intl.NumberFormat().format(
          Math.round(
            Number(e.target.value) +
              Number(money.cash ? money.cash : 0) +
              Number(money.mobile ? money.mobile : 0) -
              Number(money.cost ? money.cost : 0)
          )
        ),
      });
    } else if (e.target.id === "mobile") {
      form.setFieldsValue({
        ttlamt: new Intl.NumberFormat().format(
          Math.round(
            Number(e.target.value) +
              Number(money.cash ? money.cash : 0) +
              Number(money.noncash ? money.noncash : 0) -
              Number(money.cost ? money.cost : 0)
          )
        ),
      });
    }
  };

  return (
    <Hotkeys keyName="f6" onKeyDown={onKeyDown}>
      <div className="col-span-6 sm:col-span-6 md:col-span-6 lg:col-span-6 xl:col-span-8 2xl:col-span-8 bg-white py-2 px-1 rounded-md flex flex-col h-full w-full">
        <div className="flex justify-between px-2 flex-col xl:flex-row 2xl:flex-row">
          <div className="col-span-1">
            <span className="text-grey">Бүгд -</span>
            <span className="text-black font-semibold ml-1">
              {renderData.length}
            </span>
          </div>
          <div className="flex gap-x-2 gap-y-2 flex-col xl:flex-row 2xl:flex-row xl:gap-y-0 2xl:gap-y-0">
            {/* <div className="grid grid-cols-1 gap-2"> */}
            <Button
              type="primary"
              className="text-center"
              onClick={handleClosePayment}
            >
              Тооцоо хаах
            </Button>
            <Button onClick={handleOpen}>Хямдрал (F6)</Button>
          </div>
        </div>
        <div className="w-full px-2 mt-2">
          <Search
            placeholder="хайх"
            className="searchInput w-full"
            onChange={(e) => setText(e.target.value)}
            onKeyDown={searchKeydown}
            value={text}
          />
        </div>
        <div className="mt-3 relative h-full">
          <div className="overflow-y-auto absolute top-0 bottom-0 w-full">
            <div className="px-2 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 gap-3">
              {renderData.map((item, i) => (
                <Components.Card key={i} i={i} item={item} {...props} />
              ))}
            </div>
          </div>
        </div>
        {isOpen ? (
          <Components.GlobalModal
            width={isPaymentClose ? 450 : 650}
            isOpen={isOpen}
            footer={null}
            title={isPaymentClose ? "Тооцоо хаах" : "Хямдрал оруулах"}
            onClose={() => setIsOpen(false)}
          >
            {isPaymentClose ? (
              <Form
                layout="inline"
                onFinish={handleOpenModal}
                form={form}
                className="p-3 grid grid-rows-1"
              >
                <p>{`Касс : ${props._auth.user.name}`}</p>
                <p>{`Огноо : ${newDate}`}</p>
                <Form.Item
                  name="cash"
                  label="Бэлэн"
                  onChange={(e) => priceChange(e)}
                  className="mt-4"
                >
                  <InputNumber
                    type="number"
                    className="w-72 float-right"
                    min={0}
                  />
                </Form.Item>
                <Form.Item
                  name="noncash"
                  label="Карт"
                  onChange={(e) => priceChange(e)}
                >
                  <InputNumber
                    type="number"
                    className="w-72 float-right"
                    min={0}
                  />
                </Form.Item>
                <Form.Item
                  name="mobile"
                  label="Мобайл"
                  onChange={(e) => priceChange(e)}
                >
                  <InputNumber
                    type="number"
                    className="w-72 float-right"
                    min={0}
                  />
                </Form.Item>
                <Form.Item
                  name="cost"
                  label="Зардал"
                  onChange={(e) => priceChange(e)}
                >
                  <InputNumber
                    type="number"
                    className="w-72 float-right"
                    min={0}
                  />
                </Form.Item>
                <Form.Item name="ttlamt" label="Нийт">
                  <Input disabled className="w-72 float-right" />
                </Form.Item>
                <Form.Item name="text" label="Зардалын тайлбар">
                  <TextArea rows={4} className="w-56 float-right" min={0} />
                </Form.Item>
                <div className="flex w-full gap-x-2 justify-center mt-4">
                  {" "}
                  <Button onClick={closeModal}>Буцах</Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    id="settlement-button"
                  >
                    Хаалт хийх
                  </Button>
                </div>
              </Form>
            ) : (
              <div className="p-3">
                <Form layout="inline" onFinish={handleDiscount} form={form}>
                  <Components.InputNumberForm
                    name="discount"
                    required={true}
                    placeholder="Хямдрал оруулах..."
                    length={7}
                    className="h-full"
                    autoFocus={true}
                    onChange={handleChangeDiscount}
                    max={props.activeProduct && props.activeProduct.price}
                    errMsg="Хямдрал оруулна уу."
                  />
                  <Form.Item name="discountPercent">
                    <InputNumber
                      placeholder="Хямдрал %"
                      className="w-full"
                      disabled
                      {...PRICE_PARSERS}
                    />
                  </Form.Item>
                  <Table
                    className="w-full"
                    columns={DiscountTableColumn}
                    dataSource={[props.activeProduct]}
                    pagination={false}
                  />

                  <div className="flex w-full gap-x-2 justify-end mt-2">
                    <Button onClick={closeModal}>Буцах</Button>
                    <Button type="primary" htmlType="submit">
                      Батлах
                    </Button>
                  </div>
                </Form>
              </div>
            )}
          </Components.GlobalModal>
        ) : null}
        <div className="hidden">
          <SaleBill
            ref={orderRef}
            type={ReceiptType.Хаалт}
            data={receiptData}
          />
        </div>
        <Components.GlobalModal
          footer={[
            <Button loading={isloading} onClick={() => setIsOpenWarning(false)}>
              Үгүй
            </Button>,
            <Button
              loading={isloading}
              type="primary"
              onClick={handlePaymentClose}
              autoFocus
            >
              Тийм
            </Button>,
          ]}
          width={400}
          isOpen={isOpenWarning}
          onClose={() => setIsOpenWarning(false)}
          title="Анхааруулга"
        >
          <div className="py-3 px-10 flex flex-col items-center justify-center">
            <span>Хаалт хийхдээ итгэлтэй байна уу?</span>
          </div>
        </Components.GlobalModal>
      </div>
    </Hotkeys>
  );
}

export default OrderProducts;
